<template>
    <div>
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <div class="row mb-3 justify-content-center">
            <div class="col-12 col-md-12" v-if="!showCreateIBMammAccount">
                <div class="d-flex align-items-center justify-content-between my-3">
                    <h2 class="mb-0">{{ $t('mampamm_account_List_Header') }}</h2>
                    <button class="common_btn btn_xs" @click="createAccount(true)">{{ $t('mampamm_account_Create') }}</button>
                </div>
                <div class="table-responsives scrollbar-x">
                    <table class="table customize">
                        <thead>
                            <tr>
                                <th>{{$t('dash_tradAccId')}}</th>
                                <th>{{$t('dash_currency')}}</th>
                                <th>{{$t('dash_Platform')}}</th>
                                <th>{{$t('Dlist_demoLive')}}</th>
                                <th>{{$t('Dlist_accountType')}}</th>
                                <th>{{$t('dash_Leverage')}}</th>
                                <th></th> 
                            </tr>
                        </thead>
                        <account-list-table v-if="(!pageLoader1 && liveAccountList != '' && liveAccountList.totalRecords > 0)" :accountlist="liveAccountList.records" :pageLoader="pageLoader1" :listType="'live'"/>
                        <loader-component :pageloader_value="pageLoader1" :type="'table'" :colspan="col_span" :list="liveAccountList" ></loader-component>
                    </table> 
                </div>
            </div>
            <div class="col-12 col-md-11 whiteBG" v-else>
                <section class="blockElement mainBanner p-4">
                    <div class="inner-banner-custom row">
                        <div class="col-12 col-md-6">
                            <div class="mamPamm-content">
                            <h2 class="mb-3">{{$t('mampamm_account_heading')}}</h2>
                                <p>{{$t('mampamm_account_description')}}</p>
                            </div>
                            <div class="featuresCol py-4">
                                <div class="main-title">
                                <h3 class="mb-3">{{$t('mampamm_account_regsiter_heading')}}</h3>
                                <!-- <p>Key features that put fxview's MAM/PAMM ahead of the curve</p> -->
                            </div>
                            <div class="mamPamm-feature mb-4">
                                <ul class="listing flexible">
                                    <li>
                                        <feather type="check"></feather>
                                        <p class="m-0">{{$t('mampamm_account_clicktobecame')}}</p>
                                    </li>
                                    <li>
                                        <feather type="check"></feather>
                                        <p class="m-0">{{$t('mampamm_account_uniquepamid')}}</p>
                                    </li> 
                                    <li>
                                        <feather type="check"></feather>
                                        <p class="m-0">{{$t('mampamm_account_createinverstor')}}</p>
                                    </li> 
                                    <li>
                                        <feather type="check"></feather>
                                        <p class="m-0">{{$t('mampamm_account_monitoracc')}}</p>
                                    </li> 
                                </ul>
                            </div> 
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <!-- <div class="main-title">
                                <h3 class="mb-3">{{$t('mampamm_account_disclaimer')}}</h3>
                            </div> -->
                            <div v-if="ibMamPdfName">
                                <div class="mamPamm-feature mb-4" >
                                    <iframe type="application/pdf" :src="handlePdfLink" style="width:100%;height:470px;" frameborder="0" allowfullscreen></iframe>
                                </div> 
                                <div class="mamPamm-feature">
                                    <form action="" method="post" v-on:submit.prevent="submit()">
                                        <div class="CustomBlockWidth SupportBlockCenter p-3 p-lg-4"> 
                                                <!-- <div class="form-group field-wrapper">
                                                    <input placeholder=" " id="name" class="float-field form-control" v-model="name"  name="name"  type="text" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('name') }" ref="nameInput"  >
                                                    <label for="name" class="float-label">{{$t('mampamm_account_username')}}</label> 
                                                    <p class="error" v-for="error in errors.collect('name')">{{$t('mampamm_account_usernameRequired')}}</p> 
                                                </div> -->
                                                <div class="form-group field-wrapper">
                                                    <input placeholder=" " id="signature"  class="float-field form-control" v-model="signature"  name="signature"  type="text" v-validate="'required'" :class="{ 'is-invalid': submitted && (errors.has('signature') || signatureError) }" ref="signatureInput" @input="event => handleInputChange(event)"  >
                                                    <label for="signature" class="float-label" :class="{ 'is-invalid': submitted && (errors.has('signature') || signatureError) }">{{$t('mampamm_account_signature')}}</label> 
                                                    <p class="error" v-for="error in errors.collect('signature')">{{$t('mampamm_account_signatureRequired')}}</p> 
                                                    <p class="error" v-if="submitted && signatureError">{{$t('mampamm_account_signatureMatchError')}}</p> 
                                                </div>
                                                <div class="form-group field-wrapper conditions-Group dob" >
                                                    <input type="checkbox" id="termscondition" class="form-control" v-model="termscondition" v-validate="'required'" name="termscondition"  :class="{ 'is-invalid': submitted && errors.has('termscondition') }" ref="termsconditionInput" ><!-- <span class="checkmark"></span> -->
                                                    <label for="termscondition">{{$t('mampamm_account_termscondition')}}</label>
                                                    <p class="error" v-if="submitted" v-for="error in errors.collect('termscondition')">{{$t('mampamm_account_termsconditionRequired')}}</p>
                                                </div>
                                            <div class="text-center">
                                                <!-- <a class="mr-3 underline" href="#" @click.prevent="backTick()">Back To Tickets</a> -->
                                                <button class="prism_btn btn_sm"> {{$t('mampamm_account_Proceed')}}</button> 
                                            </div>
                                            <!-- <div class="text-center">
                                                <button class="prism_btn btn_sm"> {{$t('mampamm_account_Cancel')}}</button> 
                                            </div> -->
                                        </div> 
                                    </form>
                                </div> 
                            </div>
                            <div class="mamPamm-feature" v-else>
                                <div class="noRecordFound border nopdf"> 
                                    <img src="/static/fxView/images/search.svg" alt="no record found">
                                    <p>{{$t('mampamm_account_No_Pdf_Found')}}</p>
                                </div>
                            </div> 
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>
<script>
    import account_list_table from '../../shared/tradingAccounts/account-list-table'
    export default {
        name: 'mam-pamm-account',
        data() {
            return {
                pageLoader: false,
                col_span : 7,
                submitted: false,
                termscondition: false,
                showCreateIBMammAccount: false,
                // name: '',
                signature: '',
                termscondition: false,
                pageLoader1 : false,
                signatureError: false,
                showButtonDetailInfo : '',
                ibMamPdfName: '',
                response_msg: '',
                msg_type: '',
            }
        },
        components: {
            accountListTable : account_list_table
        },
        computed: {
            handlePdfLink(){
                // return 'static/fxView/pdf/IB_MAMM_PAMM_ACCOUNT.pdf#view=FitH';
                return this.$env_var.ibMamPdfLink+this.get_user.profile.user_id+'&doc='+this.ibMamPdfName+'#view=FitH';
            },
        },
        methods:{
            createAccount(data) {
                this.showCreateIBMammAccount  = data;
                this._runGetIbPdfName({'globalParams' :{},'localParams' :{ "parameter" : this } });
            },
            detailDiv(index,getData,account_id,act_account_id) {
                if(getData == 'div'){
                    var element = document.getElementById(getData+index)
                    if ($(element).hasClass('hide')){
                        $(element).removeClass('hide');
                    }else{
                        $(element).addClass('hide');
                    } 
                }else{
                    if(parseInt(this.showButtonDetailInfo) == index){
                        this.showButtonDetailInfo = ''
                    }else{
                        this.showButtonDetailInfo = index
                    }
                }
            },
            handleInputChange(e) {
                this.signatureError = false;
            },
            submit() {
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        const { username } = this.get_user;
                        // const name = firstname + ' ' + lastname
                        if (_that.signature.toLowerCase() === username.toLowerCase()) {
                            let input_json={
                                'globalParams' :{
                                    // 'name' : _that.name,
                                    'signature' : _that.signature,
                                    'terms_agreed' : _that.termscondition ? "1" : _that.termscondition,
                                },
                                'localParams' :{ "parameter" : _that }
                            }
                            _that._runCreateIBMamPammAccount(input_json)
                        } else {
                            _that.signatureError = true;
                        }
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
        },
        created(){
            this.showCreateIBMammAccount = !(Object.keys(this.ibMamPammAccountList.records).length > 0 && this.ibMamPammAccountList.totalRecords > 0);
		},
        mounted() { 
            const _that = this
            $(document).on("click", function(event){
                if(!$(event.target).closest('.dotAreaForButton').length){
                    _that.showButtonDetailInfo = ''
                }
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/socialTrade/pages/mam_pamm_accounts.vue